import {
  getDayLocFrequency,
  getFormattedLocBudgetAmount,
  getWeekLocDates,
} from 'src/models/LineOfCreditModelUtils';
import { EntityName } from 'src/types/EntityName';
import { ILineOfCreditResponseType } from 'src/types/LineOfCredit';
import { sdk } from 'src/utilities/sdk';
import { LineOfCreditSearchType } from 'src/utilities/useSearchHooks';

export enum LineOfCreditTabIndex {
  ACTIVE,
  INACTIVE,
}

export const TAB_SEARCH_TYPE_MAP: Record<
  LineOfCreditTabIndex,
  LineOfCreditSearchType
> = {
  [LineOfCreditTabIndex.ACTIVE]: LineOfCreditSearchType.ACTIVE,
  [LineOfCreditTabIndex.INACTIVE]: LineOfCreditSearchType.INACTIVE,
};

export interface LineOfCreditLandingEmptyStateCopy {
  emptyStateTitle: string;
  emptyStateDescription: string;
}

export const getLineOfCreditLandingEmptyStateCopy = ({
  entityName,
  searchType,
}: {
  entityName: EntityName;
  searchType: LineOfCreditSearchType;
}): LineOfCreditLandingEmptyStateCopy => {
  return searchType === LineOfCreditSearchType.ACTIVE
    ? {
        emptyStateTitle: `No ${entityName.plural} yet`,
        emptyStateDescription: `Create a ${entityName.singular} and add people to it so they can order with Grubhub`,
      }
    : {
        emptyStateTitle: `No inactive ${entityName.plural}`,
        emptyStateDescription: `Your inactive ${entityName.plural} will appear here`,
      };
};

export interface GroupCounts {
  group_id: string;
  diner_count: number;
}

export interface LocCountsResponse {
  object: {
    group_counts: GroupCounts[];
  };
}

export async function getDinerCounts(
  corpId: string,
  ids: string[]
): Promise<LocCountsResponse> {
  return sdk.http.post(
    `/corps/${corpId}/diners/search/diner_count_per_group/`,
    ids
  );
}

export const getGroupIdsFromLocList = (
  locs: ILineOfCreditResponseType[]
): string[] => {
  return Array.from(
    locs.reduce((acc, loc) => {
      loc.tag_invites.forEach(({ id }) => acc.add(id));
      return acc;
    }, new Set<string>())
  );
};

export const getLocHasDiners = (
  loc: ILineOfCreditResponseType,
  dinerCountPerGroups: Record<string, number>
): boolean => {
  return loc.tag_invites?.some(({ id }) => Number(dinerCountPerGroups[id]) > 0);
};

export const getLocDescription = (loc: ILineOfCreditResponseType): string => {
  const DATE_FORMAT = 'MMM d';
  if (loc.budget_reset_period === 1) {
    return `${getFormattedLocBudgetAmount(loc)} ${
      getDayLocFrequency(loc).short
    }`;
  }
  return `${getFormattedLocBudgetAmount(loc)} ${getWeekLocDates({
    loc,
    format: DATE_FORMAT,
  })} ${loc.repeating ? 'every week' : ''}`;
};
